import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { updatedSelectedAppointmentTypes } from '../../../Redux/Actions/Contract.Globals.Actions';

function GroupingNavMenu({
	anchorEl,
	path,
	onClose
}) {
	const { isLoaded, options } = useSelector(state => state.contract_globals.appointment_types);
	const dispatch = useDispatch();
	const history = useHistory();

	function handleGroupingChange(grouping) {
		updatedSelectedAppointmentTypes(grouping)(dispatch);
		onClose();
	}

	function handleKeyPress(target, grouping, path) {
		if (target.key === "Enter")
		{
			handleGroupingChange(grouping);
			history.push(path);
		}
	}

	return (
		<Menu anchorEl={anchorEl} keepMounted open={!!anchorEl} onClose={onClose} style={{ width: '100%' }}>
			{isLoaded && options.map((grouping, index) => {
				return (
					<MenuItem key={index} onClick={e => handleKeyPress(e, grouping, path)}>
						<Link
							style={{ color: '#1d2a59' }}
							onClick={() => handleGroupingChange(grouping)}
							to={{
								pathname: path,
								state: { title: grouping.key }
							}}
                            tabIndex="-1"
                            aria-hidden="true"
						>
							{grouping.key}
						</Link>
				    </MenuItem>
			    );
			})}
		</Menu>
	);
}

export default GroupingNavMenu;